import { Box, Button, Stack, TextField, Typography } from '@mui/material';
import React, { useState } from 'react';

interface Props {
  busy: boolean;
  add: (title: string, url: string) => Promise<void> | void;
}

const isWebAddress = (value: string) => /^https?:\/\/\S+$/i.test(value.trim());

/** Adds a link (for example to a document hosted elsewhere) to the offer's documents. */
export default function OfferLinkForm({ busy, add }: Props) {
  const [title, setTitle] = useState('');
  const [url, setUrl] = useState('');
  const urlProblem = url.trim() && !isWebAddress(url) ? 'Start the address with https://' : '';

  const submit = async () => {
    if (!title.trim() || !isWebAddress(url)) return;
    await add(title.trim(), url.trim());
    setTitle('');
    setUrl('');
  };

  return (
    <Stack spacing={1.5}>
      <Typography variant="body2" color="text.secondary">
        Or add a link to a document published elsewhere.
      </Typography>
      <Box sx={{ display: 'grid', gap: 2, gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' } }}>
        <TextField
          label="Link title"
          size="small"
          value={title}
          onChange={(event) => setTitle(event.target.value)}
          inputProps={{ maxLength: 120 }}
        />
        <TextField
          label="Web address"
          size="small"
          value={url}
          placeholder="https://"
          error={Boolean(urlProblem)}
          helperText={urlProblem || ' '}
          onChange={(event) => setUrl(event.target.value)}
        />
      </Box>
      <Box>
        <Button
          variant="outlined"
          disabled={busy || !title.trim() || !isWebAddress(url)}
          onClick={submit}
        >
          Add link
        </Button>
      </Box>
    </Stack>
  );
}
